import { useRouter } from 'next/router';
import type { ReactNode } from 'react';
import { SignupStatusScreen } from '@/components/auth/SignupStatusScreen';
import { useBannedUser } from '@/contexts/BannedUserContext';
import { BRAND_CHOOSER_PATH } from '@/lib/appBootstrap/signedInLanding';

// gloss
export const BannedGuard = ({ children }: { children: ReactNode }) => {
  const { blockedState, message, supportEmail } = useBannedUser();
  const router = useRouter();

  if (blockedState && router.pathname !== BRAND_CHOOSER_PATH) {
    return (
      <SignupStatusScreen
        variant={blockedState}
        message={message ?? undefined}
        supportEmail={supportEmail ?? undefined}
      />
    );
  }

  return children;
};
